import { CheckIcon } from "@icons";
import styles from "./AccrualDocumentImporter.module.scss";

interface Props {
    isMapped: boolean;
}

export const AccrualImporterCounterpartyStatus: React.FC<Props> = ({
    isMapped,
}) => {
    if (!isMapped) {
        return null;
    }

    return (
        <span className={styles.mappedStatus}>
            <CheckIcon className="icon-color-current" />
            Mapped
        </span>
    );
};
